import React from "react";
import { RegisterSuccess } from "./registerSuccess";
import { RegisterHome } from "./registerHome";
import { useStepper } from "../../../features/stepper";
import { RegisterIntro } from "./registerIntro";

export const Register : React.FC = () => {

    const [step, increaseStep, decreaseStep] = useStepper(0)

    const Component = [
        RegisterIntro,
        RegisterHome,
        RegisterSuccess
    ][step];

    return <Component increaseStep={increaseStep} decreaseStep={decreaseStep}/>
}